import React, { useEffect, useState } from "react";
import { InsightCard, TanPriceCard, UserStat, Chart, LiveSupportCard, RecentActvCard } from "../../components";
import { axiosInstance } from "../../utils";

const Home = () => {

   const [getDashboard, setGetDashboard] = useState(null);

  useEffect(() => {
      const token = localStorage?.getItem("token");
      axiosInstance.get("/api/admin/dashboard-data", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then(res => {
         setGetDashboard(res.data?.data)
      }).catch(err => console.log(err))
    

  }, []);

  const convertToNum = Number(getDashboard?.totalGoldHeldWithCustomers);
  const round = Math.round(convertToNum);
  
   
   const totalTrans = getDashboard?.totalTransactions === undefined || NaN ? "20" : getDashboard?.totalTransactions; 
   const avaStokes = round == NaN ? round : "10";
   const totalBuy = getDashboard?.totalBuyGold === undefined || NaN ? "10" : getDashboard?.totalBuyGold;
   const totalSell = getDashboard?.totalSellGold === undefined || NaN ? "8" : getDashboard?.totalSellGold;


  return <section className="container py-10">
    <div className="grid lg:grid-cols-4 lg:grid-rows-4 gap-x-4 gap-y-4 md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 pb-4">
      <div className="bg-white w-full lg:col-start-1 lg:row-start-1 md:col-start-1 sm:col-start-1 col-start-1 h-full p-6 rounded-lg">
        <InsightCard heading="Total Profit" price="202K" bgColor="bg-primary-red-500" />
      </div>
      <div className="bg-white w-full lg:col-start-2 lg:row-start-1 md:col-start-1 sm:col-start-1 col-start-1 h-full p-6 rounded-lg">
      <InsightCard heading="Total transaction" price={`${totalTrans}K`} bgColor="bg-primary-green" />
      </div>
      <div className="bg-white w-full lg:col-start-3 lg:row-start-1 md:col-start-1 sm:col-start-1 col-start-1 h-full p-6 rounded-lg">
      <InsightCard heading="Available Stoke" price={`${avaStokes}KG`} bgColor="bg-primary-blue" />
      </div>
      <div className="lg:row-span-2 lg:col-span-1 sm:col-start-1 md:col-start-1 col-start-1 w-full">
        <UserStat />
      </div>
      
    
      <div className="lg:col-span-3 lg:row-span-3 col-start-1 md:col-start-1 sm:col-start-1">
        <Chart />
      </div>
      <div className="w-full  lg:row-span-2 lg:col-span-1 col-start-1 md:col-start-1 sm:col-start-1">
        <TanPriceCard totalBuyGold={totalBuy} totalSellGold={totalSell} />
      </div>

    </div>
    <div className="flex gap-3 pb-3 md:flex-col sm:flex-col flex-col lg:flex-row">
      <LiveSupportCard />
      <RecentActvCard />
    </div>

  </section>;
};

export default Home;
